export enum AuroraEnv {
  PRODUCTION = 'PROD',
  STAGING = 'STAGING',
  LOCAL = 'LOCAL',
}

export const auroraProdSubDomains = ['prod', 'kueskipay', 'app'] as const;
export const auroraStageSubDomains = ['testing', 'staging'] as const;
export const auroraLocalSubDomains = ['localhost'] as const;
export const auroraProdDomains = ['kueskipay-aurora.kueski.com'];
export const auroraStageDomains = ['kueskipay-aurora.kueski.codes'];

export type AuroraSubDomain = (
  typeof auroraProdSubDomains[number]
  | typeof auroraStageSubDomains[number]
  | typeof auroraLocalSubDomains[number]
);
export type AuroraEnvMapping = Record<AuroraSubDomain, AuroraEnv>;
